import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import utils from "../../../utils/validateScanner"


export default {
	name: 'bagroutemodechanges',
	mixins: [utils],
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading,
		DatePicker
	},
	data: function() {
		return {
			pageCount: 0,
			pageNo: 0,
			pageLimit: 5,
			totalRows: 0,
			resultCount: 0,

			isLoading: false,
			bagno: '',
			FromDate: '',
			ToDate: '',
			bagstatus: '',
			validListFlag: false,
			listBagData: [],
			showAddBagFlag: false,

			routeMode: '',
			bagnoadd: '',
			comment: '',
			userHubid: '',

			listChangeResult: [],
			apiResponseFlag: false,

			changeRequest: false,
			bagroutemodechangeid: '',
			routeModeUpdate: '',
			commentUpdate: '',

			commentUpdateError: false,
			routeModeUpdateError: false,

		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.userHubid = userdetail[0].HubId[0];

	},
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},

		showBagRouteChangeForm() {
			this.showAddBagFlag = true;
			this.validListFlag = false;
			this.resetForm();
		},
		hideBagRouteChangeForm() {
			this.clearChangeRouteForm();
			this.showAddBagFlag = false;
			this.apiResponseFlag = false;
		},
		openchangeRequestPopUp(data) {
			this.routeModeUpdate = '';
			this.commentUpdate = '';
			this.bagroutemodechangeid = data.bagroutemodechangeid;
			this.changeRequest = true;
		},
		closechangeRequestPopUp() {
			this.changeRequest = false;
		},
		// Function to Get the list of  Bags
		getBagRouteList() {
    console.log(this.pageNo);
			if (this.validateFlag == true) {
				this.input = ({})
				axios({
						method: 'GET',
						'url': apiUrl.api_url_hubops + 'bagRouteModeChangeRequestListAll?BagNo=' + this.bagno + '&Status=' + this.bagstatus + '&FromDate=' + this.dateFormat(this.FromDate) + '&ToDate=' + this.dateFormat(this.ToDate) + '&PageSize=' + this.pageLimit + '&PageIndex=' + this.pageNo,
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
						}
					})
					.then(result => {
						this.isLoading = false;
						if (result.data.ResultCode == 100) {
							if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
								this.colorCode = result.data.lossCategorization.colorCode;
								this.colorIcon = result.data.lossCategorization.icon;
							}
							this.validListFlag = true;
							this.listBagData = result.data.ResponseData;
							let totalRows = result.data.TotalCount;
							this.resultCount = result.data.TotalCount;
							if (this.resultCount > 0) {
								if (totalRows < this.pageLimit) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(totalRows / this.pageLimit)
								}
							}
						} else {
							this.validListFlag = false;
							this.$alertify.error(result.data.ReturnMessage);
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			} else {
				return false;
			}
		},

		//to get target id in active/inactive modal
		saveChangeBagRoute() {

			if (this.bagnoadd == '') {
				return false;
			}
			if (this.comment == '') {
				return false;
			}
			if (this.comment == '') {
				return false;
			}
			this.isLoading = true;

			this.input = ({
				BagNos: this.bagnoadd,
				Comment: this.comment,
				RequestedRouteMode: this.routeMode,
				LastModifiedBy: this.useremail,
				CurrentHubId: this.userHubid.toString()
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'bagRouteModeChangeRequestRaiseRequest',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 100) {
						this.$alertify.success('Request Sent Successfully');
						this.listChangeResult = result.data.ResponseData;
						this.apiResponseFlag = true;
					}
					//this.getGroupTemplates();
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		updateChangeRequest() {

			if (this.commentUpdate == '') {
				this.commentUpdateError = true;
				return false;
			} else {
				this.commentUpdateError = false;
			}
			if (this.routeModeUpdate == '') {
				this.routeModeUpdateError = true;
				return false;
			} else {
				this.routeModeUpdateError = "";
			}

			this.isLoading = true;

			this.input = ({
				BagRouteModeChangeId: this.bagroutemodechangeid,
				RequestedRouteMode: this.routeModeUpdate,
				Comment: this.commentUpdate,
				LastModifiedBy: this.useremail,
			})

			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'updateBagRouteModeChangeRequest',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 500) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage)
					}
					if (result.data.ResultCode == 100) {
						this.$alertify.success('Bag RouteMode Changed Request Updated Successfully');
						// Now Resetting the Form
						this.commentUpdateError = false;
						this.routeModeUpdateError = false;
						this.changeRequest = false;
						this.commentUpdate = '';
						this.routeModeUpdate = '';
            this.getBagRouteList();
					}
					//this.getGroupTemplates();
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1);
			this.getBagRouteList();
		},

		//to reset search form
		resetForm() {

			this.bagno = '';
			this.FromDate = '';
			this.ToDate = '';
			this.bagstatus = '';
			this.pageCount = 0;
			this.pageNo = 0;
			this.listBagData =[];
			this.validListFlag = false;
			document.getElementById("bagno").value = "";
			//console.log(this.modeObjData);
			this.$validator.reset();
			this.showHideCodeIconInput();

		},

		clearChangeRouteForm() {
			this.bagnoadd = '';
			this.routeMode = '';
			this.comment = '';
			this.$validator.reset();
		},

		//validate all form fields on onsubmit()
		onSubmit: function(formname) {
			this.$validator.validateAll().then((formResult) => {
					console.log(formResult);
					if (formResult == false) {
						this.validateFlag = false
					} else {
						this.validateFlag = true;
						if (this.showAddBagFlag == false) {
							this.pageNo = 0;
							this.getBagRouteList();
						} else {
							//this.saveChangeBagRoute();
						}
						console.log('form is valid')
					}

				})
				.catch(() => {
					console.log('errors exist')
				});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/RouteModeChangeRequest/RouteModeChangeRequest_component.js